export const convertToRem = number => number * 0.06 + "rem";